import { useState } from 'react'

export const useForceRerender = (): [number, () => void] => {
  const [key, setKey] = useState(0)
  const forceRerender = () => setKey((prevKey) => prevKey + 1)
  return [key, forceRerender]
}
